import { useServicesContext } from '../../contexts/ServicesContext';
import { useMutation } from '@tanstack/react-query';

export enum DeleteBlobCacheKey {
  DeleteBlob = 'DeleteBlob',
}

export const useDeleteBlobMutation = () => {
  const { deleteBlob } = useServicesContext();

  return useMutation({
    mutationKey: [DeleteBlobCacheKey.DeleteBlob],
    mutationFn: (blobName: string) => deleteBlob({ blobName }),
  });
};
